import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BlobFileApiModel, DocumentApiModel } from '@app/api/api-models';
import { toQueryParams } from '@app/shared/utils';
import { UploadFileService } from '@app/shared/services/upload-file.service';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class SupportingDocumentsService {
  public apiUrl = 'supporting-documents';

  constructor(private readonly http: HttpClientService, private readonly uploadFileService: UploadFileService) {}

  public get(instanceId: number): Observable<DocumentApiModel[]> {
    const params = toQueryParams({
      instanceId: instanceId
    });

    return this.http.get<DocumentApiModel[]>(`${this.apiUrl}`, { params: params });
  }

  public upload(instanceId: number, file: File): Observable<HttpEvent<DocumentApiModel>> {
    const params = toQueryParams({
      instanceId: instanceId
    });

    const payload = new FormData();

    this.uploadFileService.append(payload, file);

    return this.http.post<HttpEvent<DocumentApiModel>>(`${this.apiUrl}`, payload, {
      params: params,
      observe: 'events',
      reportUploadProgress: true
    });
  }

  public download(id: string): Observable<BlobFileApiModel> {
    return this.http
      .get<DocumentApiModel>(`${this.apiUrl}/${id}`)
      .pipe(map((x) => new BlobFileApiModel().deserialize(x)));
  }

  public delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
